type UsingDefaultConfigurationVisitor = <ACCEPT>(visitor: {
   withDefaultConfiguration: () => ACCEPT;
   withIndividualConfiguration: () => ACCEPT;
}) => ACCEPT;

export const usingDefaultConfigurationVisitor = (
   usingDefaultConfiguration: boolean
): UsingDefaultConfigurationVisitor => (visitor) => {
   return usingDefaultConfiguration ? visitor.withDefaultConfiguration() : visitor.withIndividualConfiguration();
};
